import { gql } from '@apollo/client';

export const PRE_REG1_CUSTOMER = gql`
query preReg1($phone: String!) {
  preReg1(phone: $phone){
  data
  status
  error
  }
}
`;

export const PRE_REG2_CUSTOMER = gql`
query preReg2($email: String!, $phone: String!) {
  preReg2(email: $email, phone: $phone){
  customer{
    firstname
    lastname
    address1
    address2
    city
    state
    zip
    phone
    email
    existingcustomer
  }
  status
  error
  }
}
`;

export const GET_CUSTOMER_PROFILE = gql`
query getProfileInformation {
  getProfileInformation{
    customer{
      firstname
      lastname
      address1
      address2
      city
      state
      zip
      phone
      email
    }
  status
  error
  }
}
`;

